import APIV5 from '~/models/api';
import KformController from '~/components/kform/kform.controller';
import _ from 'lodash-es';
import $ from 'jquery';

/* globals Knitiv */

/**
 * @typedef SmartFieldOptions
 * @property {boolean} displaySuggestBtn
 * @property {boolean} displayInputPopup
 */

export default class SmartFieldController {
	/* @ngInject */
	/**
	 * @param {import('angular').IAttributes} $attrs
	 * @param {import('angular').ICompileService} $compile
	 * @param {import('angular').IDocumentService} $document
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').IParseService} $parse
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IPositionService} $uibPosition
	 * @param {import('angular').IWindowService} $window
	 * @param {any} MethodService
	 * @param {any} mfParser
	 */
	constructor(
		$attrs,
		$compile,
		$document,
		$element,
		$filter,
		$parse,
		$q,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibPosition,
		$window,
		MethodService,
		mfParser,
	) {
		/**
		 * Pre-selected match indexes on mouse over or using keyboard navigation
		 *
		 * @type {any[]}
		 */
		this.active = [];

		/**
		 * API Options
		 *
		 * @type {any}
		 */
		this.apiOptions = {};

		/**
		 * Should the typeahead popup be appended to $body instead of the parent element?
		 *
		 * @type {boolean}
		 */
		this.appendToBody = false;

		/** @type {?string} */
		this.classHelper = null;

		/** @type {SmartFieldOptions} */
		this.defaultOptions = {
			displaySuggestBtn: false,
			displayInputPopup: false,
		};

		/** @type {boolean} */
		this.disabled = false;

		this.hasFocus = false;

		this.input = null;

		/** @type {boolean} */
		this.loading = false;

		/**
		 * Matches displayed in popup
		 *
		 * @type {any[]}
		 */
		this.matches = [];

		/** @type {string} */
		this.message = '';

		this.newName = undefined;

		/** @type {any} */
		this.ngModel = undefined;

		/**
		 * Model controller
		 *
		 * @type {?import('angular').INgModelController}
		 */
		this.ngModelCtrl = null;

		/**
		 * ngModel options
		 *
		 * @type {any}
		 */
		this.ngModelOptions = {};

		/**
		 * @type {any[]}
		 */
		this.oldMatches = [];

		/**
		 * Create callback
		 *
		 * @type {?Function}
		 */
		this.onCreate = null;

		/**
		 * Suggestion pop-up flag
		 *
		 * @type {boolean}
		 */
		this.onSuggestion = false;

		/** @type {SmartFieldOptions} */
		this.options = { ...this.defaultOptions };

		/**
		 * @type {import('@knitiv/api-client-javascript').KNodeMF}
		 */
		this.order = 'ALL';

		/**
		 * @type {any}
		 */
		this.parserResult = undefined;

		/**
		 * kform controller
		 *
		 * @type {?KformController}
		 */
		this.parent = null;

		/**
		 * Input placeholder
		 *
		 * @type {string}
		 */
		this.placeholder = '';

		this.qrcode = undefined;

		/**
		 * User input query
		 *
		 * @type {string}
		 * @description we need to propagate user's query so we can higlight matches
		 */
		this.query = '';

		this.readOnly = false;

		/**
		 * Display the results popup
		 *
		 * @type {boolean}
		 */
		this.showSuggestion = false;

		/**
		 * Static results list matches
		 *
		 * @type {any[]}
		 */
		this.smartFieldList = [];

		/**
		 * Static results list matches from smartFieldList directive
		 *
		 * @type {any}
		 */
		this.smartFieldParse = {
			enabled:         false,
			matches:         [],
			parseFromSource: undefined,
		};

		/** @type {any} */
		this.smartFieldValidate = {};

		/** @type {?Event} */
		this.smartFieldEvent = null;

		/** @type {number | undefined} */
		this.tabindex = undefined;

		/** @type {boolean} */
		this.valid = true;

		this.$attrs = $attrs;
		this.$compile = $compile;
		this.$document = $document;
		this.$element = $element;
		this.$filter = $filter;
		this.$parse = $parse;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibPosition = $uibPosition;
		this.$window = $window;
		this.MethodService = MethodService;
		this.mfParser = mfParser;

		this.$inputElement = $($element).find('input.form-control');

		/** @type {?import('jquery')} */
		this.$popUpElement = null;
	}

	/**
	 * Keep reference to click handler to unbind it.
	 *
	 * @param {Event} event
	 */
	dismissClickHandler(event) {
		// @ts-ignore
		const outsidePopupClick = $(event.target).closest(this.$element).length === 0
			// @ts-ignore
			&& $(event.target).closest(this.$popUpElement).length === 0
			// @ts-ignore
			&& $(event.target).closest(this.$inputElement).length === 0;

		// Firefox treats right click as a click on document
		// noinspection JSUnresolvedVariable
		if (
			(
				!outsidePopupClick
				// @ts-ignore
				&& this.multipleselection === false && event.which !== 3
				&& this.matches.length > 0 && !this.showSuggestion
			)
			|| (this.showSuggestion && this.matches.length === 0)
			|| (
				// @ts-ignore
				outsidePopupClick && this.$inputElement && this.$inputElement[0] !== event.target
				&& (
					(
						// @ts-ignore
						$(event.target).closest('mf').find('mf-popup').scope() && this.$popUpElement.scope()
						// @ts-ignore
						&& this.$popUpElement.scope().$id !== $(event.target).closest('mf').find('mf-popup').scope().$id
					)
					// @ts-ignore
					|| !$(event.target).closest('mf').find('mf-popup').scope()
				)
			)
		) {
			this.resetMatches();

			this.$timeout(() => {
				this.$scope.$apply();
			});
		}
	}

	/**
	 * Display message under the input element
	 *
	 * @param {number|boolean} nbOfSuggestions Number of suggestions
	 * @param {boolean} showHelpButton Show the help icon
	 * @param {string | undefined} message Message string
	 */
	displayHelper(nbOfSuggestions, showHelpButton, message = undefined) {
		this.classHelper = 'red';
		if (showHelpButton) {
			if (typeof nbOfSuggestions === 'number' && nbOfSuggestions > 0) {
				this.classHelper = 'blue';
				this.message = this.$filter('sprintf')(this.$translate.instant(
					'smart-field.available-suggestions',
				), nbOfSuggestions);
			}
			else {
				this.classHelper = 'green';
				this.message = nbOfSuggestions === false
					? message || this.$translate.instant('smart-field.selected-item')
					: message || this.$translate.instant('smart-field.new-item');
			}
		}
	}

	/**
	 * Display results in autocomplete/suggestion popup-list
	 *
	 * @param {any} response Response object from API
	 */
	displayResults(response) {
		const results = response.result;
		const onCurrentRequest = this.ngModelCtrl && this.query === this.ngModelCtrl.$viewValue;

		this.recalculatePosition();

		// if ('autocomplete' in response && onCurrentRequest && this.hasFocus) {
		// 	results = response.result;
		// }
		// else if ('suggestion' in response) {
		// 	results = response.result;
		// }

		if (results) {
			this.matches.length = 0;

			if (results.length > 0) {
				this.active.length = 0;

				let nextItemSeparator = false;
				let index = 0;

				for (const result of results) {
					if (typeof result === 'object') {
						if (result.kid === 'ITEM_SEPARATOR') {
							nextItemSeparator = true;
						}
						else {
							if (nextItemSeparator) {
								result.sep = true;
								nextItemSeparator = false;
							}
							else {
								result.sep = false;
							}
							result.level = 0;
							result.path = [index++];
							result.expanded = false;
							result.matches = [];
							// eslint-disable-next-line unicorn/consistent-destructuring
							this.matches.push(result);
						}
					}
				}

				// eslint-disable-next-line unicorn/consistent-destructuring
				this.$inputElement.attr('aria-expanded', 'true');
			}
			else if (!this.query) {
				this.resetMatches();
			}
		}
		if (onCurrentRequest || this.onSuggestion) {
			if (this.onSuggestion) {
				this.showSuggestion = true;
			}
			this.loading = false;
			this.onSuggestion = false;
		}
	}

	/**
	 * Generates matches array or prepare order for API
	 *
	 * @param {string} inputValue Input value
	 * @returns {Promise<any>}
	 */
	async getMatches(inputValue) {
		// Local source
		if (this.parserResult) {
			const locals = { $viewValue: inputValue };
			this.loading = true;
			try {
				const matches = await this.parserResult.source(this.$scope, locals);

				// it might happen that several async queries were in progress if a user were typing fast
				// but we are interested only in responses that correspond to the current view value
				const onCurrentRequest = inputValue === this.ngModelCtrl?.$viewValue;
				if (onCurrentRequest && this.hasFocus && matches && matches.length > 0) {
					this.query = inputValue;
				}
				if (onCurrentRequest) {
					this.loading = false;
					this.$inputElement.trigger('change');
				}
			}
			catch (error) {
				console.error(error);
				this.loading = false;
			}
		}
		else if (this.hasFocus) {
			// Remote source (call API)
			this.query = inputValue;
			const form = this.parent?.forms[this.parent?.currentKid];
			this.message = '';
			if (this.inputCheck(inputValue)) {
				this.loading = true;
				this.ngModelCtrl?.$setValidity('notLoading', false);
				try {
					const output = await APIV5.instance.input(
						{
							order:    this.order,
							query:    inputValue,
							lang_kid: null,
							parent:   form ? {
								isa: form.isa.objid,
								kid: form.create ? undefined : form.kid,
							} : null,
						},
						{ id: 'smart-field.get-matches' },
					);
					const onCurrentRequest = true;

					if (this.$inputElement.val() === output.query) {
						// Node Existing :
						if (output.identical?.kid) {
							this.displayHelper(false, true, output.identical.valid_msg);
							this.select(output.identical);
							this.newName = output.identical.name;
							this.valid = output.identical.valid === undefined ? true : output.identical.valid;
							this.ngModelCtrl?.$validate();
						}
						else if (
							this.options.displayInputPopup
							&& 'suggest' in output
							&& output.suggest.length > 0
						) { // We have suggestion :
							this.displayResults({
								result: output.suggest.map(row => ({
									...row,
									selectable: 1,
								})),
							});
							if (this.ngModel?.kid) {
								this.ngModel.kid = undefined;
							}
							this.setModelValue(this.$scope, undefined);
							this.valid = false;
							this.ngModelCtrl?.$validate();
						}
						else { // We need to create :
							this.displayHelper(0, true);
							this.select({
								isa:  this.order,
								name: this.$inputElement.val(),
								// query: this.query,
							});
							this.newName = this.query;
							this.valid = true;
							this.ngModelCtrl?.$validate();
						}
					}

					this.loading = false;
					this.ngModelCtrl?.$setValidity('notLoading', true);
					this.$timeout(() => {
						/** @type {HTMLInputElement} */
						// @ts-ignore
						const inputElement = this.$inputElement.get(0);
						const cursorPosition = inputElement?.selectionStart;
						this.$inputElement.trigger('focus');
						inputElement?.setSelectionRange(cursorPosition, cursorPosition);
						if (onCurrentRequest) {
							this.$inputElement.trigger('change');
						}
					});
				}
				catch (error) {
					console.error(error);
					this.loading = false;
					this.ngModelCtrl?.$setValidity('notLoading', true);
					this.$timeout(() => {
						this.$inputElement.trigger('focus');
					});
				}
			}
		}
	}

	/**
	 * @param {string} inputValue
	 * @returns {boolean}
	 */
	inputCheck(inputValue) {
		let returnValue = true;

		if (
			(this.smartFieldValidate.minLength && inputValue.length < this.smartFieldValidate.minLength)
			|| (this.smartFieldValidate.maxLength && inputValue.length > this.smartFieldValidate.maxLength)
			|| (this.smartFieldValidate.pattern && !new RegExp(this.smartFieldValidate.pattern, 'g').test(inputValue))
		) {
			returnValue = false;
		}

		return returnValue;
	}

	/**
	 * Recalculate actual position and set new values to scope after digest loop is popup in right position
	 */
	recalculatePosition() {
		this.position = this.appendToBody
			? this.$uibPosition.offset(this.$inputElement) : this.$uibPosition.position(this.$inputElement);
		this.position.top += this.$inputElement.prop('offsetHeight');
	}

	/**
	 * Reset the matches array result
	 */
	resetMatches() {
		if (this.matches.length > 0 && !this.showSuggestion) {
			this.oldMatches = this.matches;
		}
		this.showSuggestion = false;
		this.matches.length = 0;
		this.active.length = 0;
		this.multipleselection = false;
		// this.mapPath.length = 0;
		this.mapIndex = -1;

		this.useKeyboard = false;
		this.$inputElement.attr('aria-expanded', 'false');
	}

	/**
	 * User selects the match item from popup-list
	 * @param {any} item Item object
	 * @param {MouseEvent} [event]
	 */
	select(item, event) {
		const value = item.kid === '__create' ? {
			isa:  this.order,
			kid:  undefined,
			name: this.query.trim(),
			// query: this.query,
		} : {
			isa:  item.isa,
			kid:  item.kid,
			name: item.name,
			// query: this.query,
		};
		this.ngModelCtrl?.$setViewValue(value);
		this.input = value.name;
		this.valid = true;
		this.setModelValue(this.$scope, value);
		this.resetMatches();

		if (item.kid === '__create' && typeof this.onCreate === 'function') {
			this.onCreate({
				$query: this.query,
				$event: event,
				$input: this.$inputElement,
			});
		}
	}

	/**
	 * Show popup-list for suggestions or autocompletion results
	 *
	 * @param {boolean} [toggle]
	 * @returns {Promise<any>} Promise result
	 */
	async showListSuggestions(toggle = false) {
		let returnValue;

		if (!this.showSuggestion) {
			this.onSuggestion = true;
			if (this.smartFieldParse.enabled) {
				await this.$timeout(() => {
					this.displayResults({
						result: this.smartFieldParse.matches,
					});
					this.onSuggestion = true;
				});
			}
			else if (this.smartFieldList?.length > 0) {
				await this.$timeout(() => {
					this.displayResults({
						result: this.smartFieldList.map(item => _.extend(item, { selectable: 1 })),
					});
					this.onSuggestion = true;
				});
			}
			else {
				this.loading = true;
				returnValue = null;
				if (this.options.displaySuggestBtn) {
					const suggestions = await APIV5.instance.mfSuggestion2(
						this.order,
						this.apiOptions,
						{ id: 'mf.show-list-suggestions' },
					);

					this.$q
						.when(suggestions)
						.then(result => {
							this.displayResults(result);
							this.onSuggestion = true;
							return true;
						})
						.catch(error => {
							console.error(error);
						});
				}
				else {
					this.$q.reject();
				}
			}
		}
		// if suggestions shown and toggle then hide
		else if (toggle) {
			this.showSuggestion = false;
		}

		return returnValue;
	}

	/**
	 *
	 * @param {string} inputValue Input value
	 * @returns {Promise<*>} Promise result
	 */
	search(inputValue) {
		this.$inputElement.val(inputValue);
		this.hasFocus = true;
		return this.getMatches(inputValue);
	}

	/**
	 * @param {any} scope
	 * @param {any} newValue
	 * @returns {any}
	 */
	setModelValue(scope, newValue) {
		const parsedModel = this.$parse(this.$attrs.ngModel);
		const invokeModelSetter = this.$parse(`${this.$attrs.ngModel}($$$p)`);

		if (typeof parsedModel(this.$scope === 'function')
			&& this.ngModelOptions.getOption('getterSetter')) {
			return invokeModelSetter(scope, { $$$p: newValue });
		}

		return parsedModel.assign(scope, newValue);
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.disabled) {
			this.readOnly = this.disabled;
		}
	}

	$onDestroy() {
		// @ts-ignore
		this.$document.off('click', event => this.dismissClickHandler(event));
		this.$inputElement.off('focus');
		if (this.appendToBody) {
			this.$popup?.remove();
		}
		// Prevent jQuery cache memory leak
		// @ts-ignore
		this.$popUpElement.remove();
	}

	$onInit() {
		// if (this.smartFieldList) {
		// 	this.parserResult = this.mfParser.parse(this.smartFieldList);
		// }

		this.$scope.$watch('$ctrl.options', () => {
			this.options = {
				...this.defaultOptions,
				...this.options,
			};
		}, true);

		// @ts-ignore
		this.$document.on('click', event => this.dismissClickHandler(event));

		// INTERNAL VARIABLES

		// model setter executed upon match selection
		// create a child scope for the MF directive so we are not polluting original scope
		// with MF-specific data (matches, query etc.)
		const scope = this.$scope.$new();
		const offDestroy = this.$scope.$on('$destroy', () => {
			scope.$destroy();
		});
		scope.$on('$destroy', offDestroy);
		this.loading = false;

		// Default progress type
		scope.moveInProgress = false;

		if ('component' in this.$scope.$parent.$parent) {
			this.kformComponentScope = this.$scope.$parent.$parent;
			this.component = this.$scope.$parent.$parent.component;
			this.$scope.builder = !!this.kformComponentScope.builder;
			this.$scope.componentId = this.kformComponentScope.componentId;
		}

		// @ts-ignore
		this.ngModelOptions = this.ngModelCtrl?.$options;

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.unique = () => {
				let valid = true;

				if (this.valid !== undefined) {
					({ valid } = this);
				}

				return valid;
			};
		}

		// WAI-ARIA
		const popupId = `smart-field-${scope.$id}-${Math.floor(Math.random() * 10_000)}`;

		/**
		 * pop-up element used to display matches
		 *
		 * @type {$} jQuery Element
		 */
		// @ts-ignore
		this.$popUpElement = $('<mf-popup/>').attr({
			pw:                 'mf-popup',
			active:             '$ctrl.active',
			'assign-is-open':   '$ctrl.assignIsOpen(isOpen)',
			collapse:           '$ctrl.collapse(item)',
			debounce:           '$ctrl.debounceUpdate',
			id:                 popupId,
			matches:            '$ctrl.matches',
			mf:                 '$ctrl',
			'move-in-progress': '$ctrl.moveInProgress',
			options:            '$ctrl.options',
			position:           '$ctrl.position',
			query:              '$ctrl.query',
			select:             '$ctrl.select(item, event)',
			selectlist:         '$ctrl.selectlist',
			'show-suggestion':  '$ctrl.showSuggestion',
		});

		// @ts-ignore
		this.$popup = this.$compile(this.$popUpElement)(scope);

		if (this.appendToBody) {
			this.$document.find('body').append(this.$popup);
		}
		else {
			this.$inputElement.closest('smart-field').append(this.$popup);
		}

		scope.debounceUpdate = this.$parse(this.ngModelOptions.getOption('debounce'))(this.$scope);
	}
}
